











































import Vue from 'vue';
import Component from 'vue-class-component';
import {AmetrasAdvancedButtonEvent} from '@/fields/button/AmetrasAdvancedButtonTemplate.interface';
import {Prop, Watch} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import {COLOR_SERVICE_INSTANCE, ColorService} from '@/services/style/color.service';
import {ICONS_SERVICE_INSTANCE, IconsService} from '@/utils/icons.service';

interface ExtendedBasicAdvancedButtonDto extends DisguiseDto.AdvancedButtonDto {
  targetAsString?: string;
}

@Component({
  mixins: [BindAttrs]
})
export default class AmetrasAdvancedButtonTemplate extends Vue {
  @Prop() fieldDefinition!: DisguiseDto.AdvancedButtonDto;
  @Prop() disabled!: boolean;
  @Prop({
    default: null
  }) title!: string;
  internalButtonConfig: ExtendedBasicAdvancedButtonDto | null = null;
  colorService: ColorService = COLOR_SERVICE_INSTANCE;
  iconService: IconsService = ICONS_SERVICE_INSTANCE;

  targetMapping: Partial<Record<DisguiseDto.EnumLinkTarget, string>> = {
    BLANK: '_blank'
  };

  created() {
    if (this.fieldDefinition) {
      // if somebody provided a value from outside
      this.internalButtonConfig = {
        loading: false,
        ...this.fieldDefinition,
        targetAsString: this.fieldDefinition.target ? this.targetMapping[this.fieldDefinition.target] || this.fieldDefinition.target : undefined
      };
    }
  }

  @Watch('fieldDefinition') modelChanges(
      newValue: DisguiseDto.AdvancedButtonDto,
      oldValue: DisguiseDto.AdvancedButtonDto
  ) {
    if (newValue !== oldValue) {
      this.internalButtonConfig = {
        loading: false,
        ...newValue,
        targetAsString: newValue.target ? this.targetMapping[newValue.target] || newValue.target : undefined
      };
    }
  }

  emitClick() {
    const eventArgs: AmetrasAdvancedButtonEvent = {};
    if (this.internalButtonConfig != null) {
      eventArgs.buttonConfig = this.internalButtonConfig;
    }
    this.$emit('ametrasAdvancedButtonClick', eventArgs);
    this.$emit('click', eventArgs);
  }

  convertButtonType(type: DisguiseDto.EnumButtonType) {
    let result = null;

    if (type) {
      switch (type) {
        case 'BUTTON': {
          result = 'button';
          break;
        }
        case 'SUBMIT': {
          result = 'submit';
          break;
        }
        case 'RESET': {
          result = 'reset';
          break;
        }
      }
    }
    return result;
  }
}
